import React, { createContext, useContext, useState } from "react";

export interface CartItem {
  id: string;
  name: string;
  price: number;
  image: string;
  size: string;
  qty: number;
  seller: string;
}

interface CartContextProps {
  cartItems: CartItem[];
  updateItem: (id: string, newData: Partial<CartItem>) => void;
}

const CartContext = createContext<CartContextProps | undefined>(undefined);

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) throw new Error("useCart must be used within CartProvider");
  return context;
};

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cartItems, setCartItems] = useState<CartItem[]>([
    {
      id: "1",
      name: "Gantavya Aloevera Face Beauty Gel - 220gm pack of 2",
      price: 97,
      image: "/Aleo Vera Gel.jpg",
      size: "Small",
      qty: 4,
      seller: "GANTAVYA NATURALS",
    },
  ]);

  const updateItem = (id: string, newData: Partial<CartItem>) => {
    setCartItems(prev =>
      prev.map(item =>
        item.id === id ? { ...item, ...newData } : item
      )
    );
  };

  return (
    <CartContext.Provider value={{ cartItems, updateItem }}>
      {children}
    </CartContext.Provider>
  );
};
